import React,{Component} from 'react';
import { connect } from 'react-redux';
// utils
import {
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage,
  Translations,
  convertStringToArray
} from '../../../../utils';
// restClient
import {eapiClient, aemHostClient} from '../../../../restClient';
// children
import MultiLineSelect from '../../../common/MultiLineSelect';
import Radiobutton from '../../../common/Radio/radioButton';
import PersistLink from '../../../common/PersistLink';
//action Creator
import { setPersons } from '../../actions/actionCreator';

class CzechRepublicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOfpaymentAuthoriserSignatories:0,
      methodFlag:false,
      dataReady : false,
      showPaymentAuthoriser:false,
      countryCzechForm:{
        authorisedRefreeForm:[],
        signatories:[],
        paymentAuthoriserSignatories:[]
      },
      id:'',
      lid:''
    };
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  loadPageState =()=>{
    var {caseId, productId} = this.props.match.params;
    var apiUrl = '';
    if(this.props.lang.currentLang.lang === 'English'){
      apiUrl =  "/countryForms/case/" + caseId + "/country/CzechRepublic?lang=en"
    }else if(this.props.lang.currentLang.lang === 'Spanish'){
      apiUrl =  "/countryForms/case/" + caseId + "/country/CzechRepublic?lang=es"
    }
    else if(this.props.lang.currentLang.lang === 'Bahasa'){
      apiUrl =  "/countryForms/case/" + caseId + "/country/CzechRepublic?lang=ba"
    }
    eapiClient(apiUrl)
    .then(({data}) => {
      this.setState({countryCzechForm:{...this.state.countryCzechForm,
        signatories : data.responseData
      }});

      eapiClient("/countryForms/case/" + caseId + "/product/" + productId )
      .then(({data}) => {
        this.setState({entityName:data.responseData.entityName})
        if(data.responseData.countryCzechForm !== undefined){
          this.setState({ countryCzechForm:{...this.state.countryCzechForm,
            authorisedRefreeForm : data.responseData.countryCzechForm.authorisedRefreeForm},
            methodFlag : true,
            id:data.responseData.id,
            lid:data.responseData.lid
        });

          if(data.responseData.countryCzechForm.paymentAuthoriserSignatories !== undefined){
            this.setState({ countryCzechForm :{...this.state.countryCzechForm,
              paymentAuthoriserSignatories:data.responseData.countryCzechForm.paymentAuthoriserSignatories
            }});
          }

          const _paymentAuthoriserSignatoriesGet = data.responseData.countryCzechForm.paymentAuthoriserSignatories;
          if(_paymentAuthoriserSignatoriesGet && _paymentAuthoriserSignatoriesGet.length > 0 && this.state.noOfpaymentAuthoriserSignatories !== _paymentAuthoriserSignatoriesGet.length) {
            this.setState({noOfpaymentAuthoriserSignatories: _paymentAuthoriserSignatoriesGet.length});
          }

          let _authorisedRefreeForm = [];
          const {authorisedRefreeForm, signatories} = this.state.countryCzechForm;
          authorisedRefreeForm.forEach(authorisedRefreeFormData => {
            _authorisedRefreeForm[signatories.findIndex(signatory => signatory.id === authorisedRefreeFormData.signatoryId)] = authorisedRefreeFormData;
          });
          this.setState({
            countryCzechForm: {...this.state.countryCzechForm, authorisedRefreeForm: _authorisedRefreeForm},
            dataReady: true
          });
        }

        else  {
          this.setState({id:data.responseData.id, lid:data.responseData.lid,
            dataReady: true
          });
        }
      });
    });
  }

  componentWillMount() {
    var {caseId} = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    let apiURL = "/aemData/formData/json_czech-republic-personal-data-consent-form";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }

    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({ formJson :data});
    });

    eapiClient("/persons/case/" + caseId)
    .then(({data}) => {
      this.props.setPersons(data.responseData);
    });


  }


  componentDidMount(){
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key'+ getCurrentDropDown);

    if(getCurrentDropDown !== null){
      var getCurrentDropDownName =  getCurrentDropDown.substring(0,getCurrentDropDown.length -1);
    }
    if(getCurrentDropDownName ==='paymentAuthoriserSignatories'){
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length -1);
    }

    if(getCurrentDropDownName === 'paymentAuthoriserSignatories'){
      if(this.state.countryCzechForm.paymentAuthoriserSignatories.length ===0 && getCurrentDropDownValue !== null){
        var _paymentAuthoriserSignatories = [...this.state.countryCzechForm.paymentAuthoriserSignatories];
        _paymentAuthoriserSignatories[0] = getCurrentDropDownValue;
        this.setState({
          countryCzechForm:{...this.state.countryCzechForm,
            paymentAuthoriserSignatories: _paymentAuthoriserSignatories}}, () => {});

          }
          this.state.countryCzechForm.paymentAuthoriserSignatories.forEach((currentValue, index, arr) =>{
            if(currentValue!==getCurrentDropDownValue && index===getCurrentDropDownIndex-1 && getCurrentDropDownValue !== null){
              var _paymentAuthoriserSignatories = [...this.state.countryCzechForm.paymentAuthoriserSignatories];
              _paymentAuthoriserSignatories[index] = getCurrentDropDownValue;
              this.setState({
                countryCzechForm:{...this.state.countryCzechForm,
                  paymentAuthoriserSignatories: _paymentAuthoriserSignatories}}, () => {});

                }else if(getCurrentDropDownValue !== null && index!==getCurrentDropDownIndex-1 && getCurrentDropDownName === 'paymentAuthoriserSignatories') {
                  var _paymentAuthoriserSignatories1 = [...this.state.countryCzechForm.paymentAuthoriserSignatories];
                  _paymentAuthoriserSignatories1[getCurrentDropDownIndex-1] = getCurrentDropDownValue;
                  this.setState({
                    countryCzechForm:{...this.state.countryCzechForm,
                      paymentAuthoriserSignatories: _paymentAuthoriserSignatories1}}, () => {});

                    }
                  })
                }

                this.props.eChannel.filter(item =>{
                  if(item.eChannelType.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:hsbcNet'
                    && item.country.value === 'urn:hsbc:cmb:gdocs:products:taxonomies:countries:CzechRepublic'){
                    this.setState({showPaymentAuthoriser:true})
                  }else {
                    this.setState({showPaymentAuthoriser:false})
                  }
                })

                window.sessionStorage.removeItem("getCurrentDropDown");
                window.sessionStorage.removeItem('key'+ getCurrentDropDown);
              }
              saveStateToSessionOnEdit = () => {
                savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
              }
              onFormSubmit = (event, apiURL) => {

              }

              onFormCancel = () => {
                this.props.history.goBack();
              }

              setAuthorised = (value, name) => {
                this.setState({previouslySignedAuthorisedRefereeForm: value});
              }

              setFormData =(index, signatoryId, id, event) => {

                let _authorisedRefreeForm = [...this.state.countryCzechForm.authorisedRefreeForm];
                const previouslySignedAuthorisedRefereeForm = event.target.value;
                if(id === undefined ) {
                  _authorisedRefreeForm[index] = {previouslySignedAuthorisedRefereeForm:previouslySignedAuthorisedRefereeForm, signatoryId};
                } else {
                  let ids = id.id;
                  _authorisedRefreeForm[index] = {previouslySignedAuthorisedRefereeForm:previouslySignedAuthorisedRefereeForm, signatoryId, id:ids};
                }

                this.setState({countryCzechForm: {...this.state.countryCzechForm, authorisedRefreeForm: _authorisedRefreeForm}});
              }

              renderFields(){
                let element=[];

                for(let i=0; this.state.countryCzechForm.signatories.length > i; i++){
                  element.push(<div className="gdocs-constent-wraper">
                  <span className="gdocs-authorised-person">
                  <b>{`${this.state.countryCzechForm.signatories[i].firstName}
                  ${this.state.countryCzechForm.signatories[i].lastName}
                  ${this.state.countryCzechForm.signatories[i].dateOfBirth!==undefined ? ',':''}
                  ${this.state.countryCzechForm.signatories[i].dateOfBirth!==undefined ?
                    this.state.countryCzechForm.signatories[i].dateOfBirth :''}`}</b>
                    </span>
                    <span className="gdocs-authorised-radio-btn">
                    <label className="gdocs-authorised-label">Yes

                    <Radiobutton setInputvalue={this.setAuthorised}
                    name={`authorisedPerson${i}`}

                    _onChange={this.setFormData.bind(this, i, this.state.countryCzechForm.signatories[i].id,
                      this.state.countryCzechForm.authorisedRefreeForm[i])}
                      value="true"
                      _value={this.state.countryCzechForm.authorisedRefreeForm[i] !== undefined ?
                        this.state.countryCzechForm.authorisedRefreeForm[i].previouslySignedAuthorisedRefereeForm:''}
                        />
                        </label>
                        <label className="gdocs-authorised-label">No

                        <Radiobutton setInputvalue={this.setAuthorised}
                        name={`authorisedPerson${i}`}

                        _onChange={this.setFormData.bind(this, i, this.state.countryCzechForm.signatories[i].id,
                          this.state.countryCzechForm.authorisedRefreeForm[i])}
                          value="false"
                          _value={this.state.countryCzechForm.authorisedRefreeForm[i] !== undefined ?
                            this.state.countryCzechForm.authorisedRefreeForm[i].previouslySignedAuthorisedRefereeForm :''}
                            />
                            </label>
                            </span>
                            </div>)
                          }
                          return element;
                        }

                        handlePaymentEditClick = (accountSignatory) => {
                          var {caseId} = this.props.match.params;
                          if(accountSignatory) {
                            this.saveStateToSessionOnEdit();
                            this.props.history.push("/case-body/country-forms/create-user/" + accountSignatory.id + '/' + caseId);
                          }
                        }
                        handlePaymentAuthoriserfieldsChange = (index, paymentAuthoriser) => {
                          let _paymentAuthoriserSignatories = [...this.state.countryCzechForm.paymentAuthoriserSignatories];
                          _paymentAuthoriserSignatories[index] =  paymentAuthoriser.id;
                          this.setState({
                            countryCzechForm:{...this.state.countryCzechForm,
                              paymentAuthoriserSignatories: _paymentAuthoriserSignatories}}, () => {});
                            }

                            onAdditionUser = () => {
                              this.setState(prevState => {
                                return {noOfpaymentAuthoriserSignatories: prevState.noOfpaymentAuthoriserSignatories+1}
                              });
                            }

                            onPaymentAuthoriserSignatoriesDeletion = (index) => {
                              let _paymentAuthoriserSignatories= [...this.state.countryCzechForm.paymentAuthoriserSignatories];
                              _paymentAuthoriserSignatories.splice(index, 1);
                              this.setState(prevState => {
                                return {
                                  noOfpaymentAuthoriserSignatories: prevState.noOfpaymentAuthoriserSignatories-1,
                                  countryCzechForm: {...prevState.countryCzechForm, paymentAuthoriserSignatories: _paymentAuthoriserSignatories}
                                }
                              });
                            }

                            saveForm =() =>{
                              var payLoad={};
                              var {caseId, productId} = this.props.match.params;
                              //countryCzechForm.authorisedRefreeForm=this.state.authorisedRefreeForm;
                              //  countryCzechForm.paymentAuthoriser = this.state.paymentAuthoriser;
                              payLoad.countryCzechForm={...this.state.countryCzechForm};
                              payLoad.caseId =caseId;
                              payLoad.productId =productId;
                              payLoad.countryFormName = "Czech Republic form";
                              payLoad.id=this.state.id;
                              payLoad.lid=this.state.lid;
                              var apiURL;

                              apiURL = "/countryForms/case/" + caseId + "/product/" + productId
                              eapiClient(apiURL,{
                                method:"PUT",
                                data: JSON.stringify(payLoad)
                              })
                              .then(({data}) => {
                              });
                              this.props.history.goBack();
                            }

    render(){
      let addAuthoriserJsx;
      var {caseId} = this.props.match.params;
      let buttonJsx =(<h3>Loading.....</h3>);
      if(this.state.formJson !== undefined){
        buttonJsx =(<div>
          <button onClick={this.saveForm} aria-label={this.translations(this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text)} className="gdocs-btn-submit"> {this.translations(this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text)}</button>
          </div>);
        }
        addAuthoriserJsx = (
          <button className="gdocs-btn-default marg-bottom" onClick={this.onAdditionUser}><i className="icon icon-add"></i> Add authoriser {this.state.noOfpaymentAuthoriserSignatories+1}</button>
        );
        let filteredPerson = [];
        let personArray = this.props.persons;
        let signatoriesArray = this.state.countryCzechForm.signatories;
        let filterArray = []
        if(this.state.countryCzechForm.signatories !== undefined){
          personArray.forEach(function(person) {
            filterArray = signatoriesArray.filter(function(signatories){
              return person.id === signatories.id
            })
            if(filterArray.length === 0){
              filteredPerson.push(person)
            }
          })
        }

        let paymentAuthoriserSignatoriesjsx =[];
        for(var i = 1; i<=this.state.noOfpaymentAuthoriserSignatories; i++) {

          paymentAuthoriserSignatoriesjsx.push(
            <div className="gdocs-australia-user-form">
              <div className="gdocs-australia-user-wrapper">
                <div className="gdocs-australia-user-position">{`${this.translations(this.state.formJson.guideContainer.rootPanel.items.guidedropdownlist_paymentAuthoriser.title)} ${i}`}</div>
                <div className="gdocs-australia-user-position">
                {<span className="delete-btn" role="button" onClick={this.onPaymentAuthoriserSignatoriesDeletion.bind(this, i-1)}><i className="icon icon-bin"></i></span>}
                {
                  filteredPerson.length > 0
                  ?(<MultiLineSelect defaultValue={this.translations(this.state.formJson.guideContainer.rootPanel.items.guidetextbox_pleaseSelect.text)}
                      requiredFields={{
                        "row1": ["firstName", "lastName"],
                        "row2": ["dateOfBirth", "countryOfResidence", "nationality"],
                        "row3": []
                      }}
                      data={filteredPerson || []}
                      value={this.state.countryCzechForm.paymentAuthoriserSignatories[i-1] ? this.state.countryCzechForm.paymentAuthoriserSignatories[i-1] : ''}
                      onEdit={this.handlePaymentEditClick}
                      _onChange={this.handlePaymentAuthoriserfieldsChange.bind(this, i-1)}
                    />)
                  :''
                }
                <span className="icon icon-add addicon"></span>
                <PersistLink
                  className="mrg-left"
                  history={this.props.history}
                  state={this.state}
                  to={'/case-body/country-forms/create-user/' + caseId}
                  data={`paymentAuthoriserSignatories${i}`}
                >
                  {this.translations(this.state.formJson.guideContainer.rootPanel.items.guidedropdownlist_paymentAuthoriser.createText)}
                </PersistLink>
              </div>
            </div>
          </div>);
        }

        const pageTitle = this.state.formJson ? this.state.formJson.guideContainer.rootPanel.items.static_text_mainTitle : {};

        return(
          (this.state.dataReady)
            ? <div className="form-container">
                <div className="form-title">
                  <h1 className="form-heading">{this.translations(pageTitle.name)}</h1>
                  <div className="gdocs-clear-float"></div>
                  <p className="pannel-sub-heading">{this.state.entityName}</p>
                  <p className="form-required-desc optional-text">{this.translations(pageTitle.text)}</p>
                </div>
                <div className="gdocs-clear-float"></div>
                <p className="gdocs-czech-par-text">{this.translations(this.state.formJson.guideContainer.rootPanel.items.static_text_text1._value)}</p>
                <div className="gdocs-clear-float"></div>
                {this.renderFields()}
                <div className="gdocs-clear-float"></div>
                <div className="gdocs-australia-user-form-wrapper">
                {
                  this.state.showPaymentAuthoriser === true
                  ? (<div>
                      <p className="gdocs-ptop-30">{this.translations(this.state.formJson.guideContainer.rootPanel.items.static_text_text2.text)}</p>
                      {paymentAuthoriserSignatoriesjsx}
                      <div className="gdocs-clear-float"></div>
                      <div>{addAuthoriserJsx}</div>
                    </div>)
                  : ''
                }
                  <div className="gdocs-clear-float"></div>
                  <div key="buttons-wrapper" className="form-buttons-section country-form-buttons-section">
                    <div className="form-buttons-wrapper">
                      {buttonJsx}
                    </div>
                  </div>
                </div>
            </div>
          : '')
        }
      }

const mapStateToProps = state => {
  return {
    persons: state.persons,
    lang:state.lang,
    eChannel: state.productDetails.echannel
  }
}

  const mapDispatchToProps = dispatch => {
    return {
      setPersons: persons => {
        dispatch(setPersons(persons));
      }
    }
  }
  export default connect(mapStateToProps, mapDispatchToProps)(CzechRepublicForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/CzechRepublicForm.js